// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"b_e","large":"b_g","title":"b_i","content":"b_k","tight":"b_m"};


//////////////////
// WEBPACK FOOTER
// ./components/pageWrap/style.css
// module id = tcm7
// module chunks = 7